import { type UseQueryResult, useQuery } from 'react-query';
import { TaxItemService } from '@wealthlane/api-services/wealthlane-tax-service';

const useGetTaxNameOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const taxNameTypes = useQuery(
    ['getTaxNames'],
    async () => {
      return await handleRequest(TaxItemService.getApiTaxApiAppTaxItemApprovedTaxItemIdsList());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return taxNameTypes;
};

export default useGetTaxNameOptions;
